<template>
  <div>
    <v-card>
      <v-card-text primary-title>
        <h2 style="color: black; font-weight: normal">
          {{ report.name | capitalize }}
        </h2>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click.stop="showDialog = true">
          Koosta aruanne
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">
          {{ report.name | capitalize }}
        </v-card-title>
        <v-card-text>
          <component
            :is="value.type"
            v-for="(value, fieldName) in report.params"
            :key="fieldName"
            v-model="reportData[fieldName]"
            :label="value.label"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="!submitBtnEnabled"
            :loading="loading"
            color="primary"
            @click="createReport"
          >
            Koosta
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ReportInfo from '@/dataAccess/dto/ReportInfo'
import YearInput from './widgets/YearInput'
import MonthInput from './widgets/MonthInput'
import ClientInput from './widgets/ClientInput'
import EmployeeInput from './widgets/EmployeeInput'

export default {
  components: { YearInput, MonthInput, ClientInput, EmployeeInput },
  props: {
    report: {
      type: ReportInfo,
      required: true
    }
  },
  data() {
    return {
      reportData: this.report.defaultData,
      showDialog: false,
      loading: false
    }
  },
  computed: {
    submitBtnEnabled() {
      for (const [, value] of Object.entries(this.reportData)) {
        if (value === null) return false
      }
      return true
    }
  },
  methods: {
    /**
     * Construct report URL and redirect to HtmlReportView
     * where the report is fetched from the constructed URL.
     */
    createReport() {
      const paramsString = Object.entries(this.reportData)
        .reduce(
          (accumulator, [key, value]) => accumulator + `${key}=${value}&`,
          ''
        )
        .replace(/&$/, '')
      this.$router.push({
        name: 'HtmlReportView',
        params: {
          reportCode: encodeURIComponent(this.report.code + '/'),
          paramsStr: encodeURIComponent('?' + paramsString),
          formats: encodeURIComponent(JSON.stringify(this.report.formats))
        }
      })
    }
  }
}
</script>

<style>
#report-container > thead > tr > td {
  font-weight: bold;
}
</style>
